import React from "react";

import { Message, Notification } from "rsuite";

let toaster = null;
let defaultDuration = 5000;
const notificationKeys = new Map();
const pendingNotificationOpenKeys = new Set();
const pendingNotificationCloseKeys = new Set();

const showMessage = (type, content, header, duration = defaultDuration) => {
    if (!toaster || !toaster.push) {
        return;
    }

    toaster.push(
        <Message type={type} header={header} showIcon closable>
            {content}
        </Message>,
        { duration }
    );
};

const rememberNotificationKey = (legacyKey, toasterKey) => {
    pendingNotificationOpenKeys.delete(legacyKey);

    if (!legacyKey || !toasterKey) {
        return;
    }

    if (pendingNotificationCloseKeys.has(legacyKey)) {
        pendingNotificationCloseKeys.delete(legacyKey);
        toaster.remove(toasterKey);
        return;
    }

    notificationKeys.set(legacyKey, toasterKey);
};

const openNotification = ({
    key,
    description,
    header,
    title,
    type,
    closable = true,
    duration = defaultDuration,
    placement,
    ...props
} = {}) => {
    if (!toaster || !toaster.push) {
        return;
    }

    const pushedKey = toaster.push(
        <Notification
            {...props}
            header={header || title}
            type={type}
            closable={closable}
        >
            {description}
        </Notification>,
        { duration, placement }
    );

    if (pushedKey && typeof pushedKey.then === "function") {
        if (key) {
            pendingNotificationOpenKeys.add(key);
        }
        pushedKey.then((resolvedKey) => rememberNotificationKey(key, resolvedKey));
        return;
    }

    rememberNotificationKey(key, pushedKey);
};

const closeNotification = (key) => {
    if (!toaster || !toaster.remove || !key) {
        return;
    }

    const toasterKey = notificationKeys.get(key);

    if (!toasterKey) {
        if (pendingNotificationOpenKeys.has(key)) {
            pendingNotificationCloseKeys.add(key);
        }
        return;
    }

    toaster.remove(toasterKey);
    notificationKeys.delete(key);
    pendingNotificationCloseKeys.delete(key);
};

const closeAllNotifications = () => {
    if (!toaster || !toaster.clear) {
        return;
    }

    toaster.clear();
    notificationKeys.clear();
    pendingNotificationOpenKeys.forEach(key => pendingNotificationCloseKeys.add(key));
};

export const Alert = {
    success: (content, duration, header) => showMessage("success", content, header, duration),
    error: (content, duration, header) => showMessage("error", content, header, duration),
    info: (content, duration, header) => showMessage("info", content, header, duration),
    warning: (content, duration, header) => showMessage("warning", content, header, duration),
    config: ({ duration } = {}) => {
        if (duration !== undefined) {
            defaultDuration = duration;
        }
    },
    setToaster: (nextToaster) => {
        toaster = nextToaster;
    },
    notification: {
        open: openNotification,
        close: closeNotification,
        closeAll: closeAllNotifications
    }
};
